(function () {
  'use strict';

  angular.module('ringbaPortal').component('campaignDedupeToggle', {
    bindings: {
      deDupeSettings: '<',
      disabled: '<',
      isPublisher: '<',
      onSettingChange: '&',
      rpcItem: '<',
      currentCampaign: '='
    },
    controller: DedupeToggleController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/campaign-dedupe-toggle/campaign-dedupe-toggle.view.html'
  });

  function DedupeToggleController() {
    'ngInject';

    const vm = this;
    vm.$onChanges = onChanges;
    vm.setToggle = setToggle;

    function onChanges(changesObj) {

      if (changesObj.deDupeSettings && changesObj.deDupeSettings.currentValue) {
        vm.selectedValue = _setSelectedValue(vm.deDupeSettings);
        vm.strict = _setStrictValue(vm.deDupeSettings);
      }

    }

    function setToggle() {
      //updated to fix bug where deDupe is not being set, null on the server is the same as false false
      //so if the server returns null, then we can set false false with no side affect
      const value = { routeToDifferent: false, routeToOriginal: false, strict: false };

      if (vm.selectedValue === 'original') {
        value.routeToOriginal = true;
        vm.showStrict = true;
      } else if (vm.selectedValue === 'different') {
        value.routeToDifferent = true;
        vm.showStrict = true;
      } else {
        vm.showStrict = false;
        vm.strict = false;
      }

      value.strict = vm.strict;

      vm.onSettingChange({ setting: value });
    }

    function _setSelectedValue(deDupeSettings) {
      if (typeof deDupeSettings !== 'undefined') {
        if (deDupeSettings.routeToOriginal) {
          vm.showStrict = true;
          return 'original';
        } else if (deDupeSettings.routeToDifferent) {
          vm.showStrict = true;
          return 'different';
        } else {
          vm.showStrict = false;
          return 'normal';
        }
      } else {
        return 'normal';
      }
    }

    function _setStrictValue(deDupeSettings) {
      if (typeof deDupeSettings !== 'undefined') {
        return deDupeSettings.strict;
      } else {
        return false;
      }
    }
  }
})();
